import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IInventoryTemplatePresetRepository } from '@/coreInfrastructureModule/interfaces/IInventoryTemplatePresetRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IInventoryTemplatePreset } from '../domains/entities/InventoryTemplate';
import { InventoryTemplatePresetAdapter } from '../adapters/InventoryTemplatePresetAdapter';

/**
 * 出力条件プリセット一覧を取得するユースケース
 */
export class GetInventoryTemplatePresetListUseCase {
  /**
   * コンストラクタ
   * @param repository - 出力条件プリセットの取得を行うリポジトリ
   */
  constructor(private readonly repository: IInventoryTemplatePresetRepository) {}

  /**
   * プリセット一覧を取得する
   */
  public Execute = async (): Promise<INetworkResult<IInventoryTemplatePreset[], IError>> => {
    const result = await this.repository.getList();
    if (result.status.type === 'success') {
      return {
        status: {
          type: 'success',
          data: InventoryTemplatePresetAdapter.toEntities(result.status.data),
        },
      };
    }

    return { status: result.status };
  };
}
